import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  carregarProjeto: async () => {
    return Vue.http.get(`/api/analytics/projeto`)
      .then(response => response.data);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/analytics/servico.js